<template>
  <div class="confirmedWithdrawal">
    <div class="tips">500元及以下，可直接申请提现。500元以上，请上传发票进行提现。发票申请步骤详见注意事项。</div>
    <div v-if="!form.receiptSign" class="informationList">
      <div class="list-item card-item" @click="goPage('/apps/my/bankSet', { look: userinfo.hasBankCard ? 1 : 0, back: 1 })">
        <div class="label">银行卡</div>
        <div class="content">
          <span v-if="postList.cardNo">{{ postList.cardNo }}</span>
          <span v-else>请填写银行卡号</span>
          <img class="icon-arrow" src="@static/images/settlement/icon_arrow.png" alt="" />
        </div>
      </div>
      <div v-if="!needSign">
        <div class="tab-wrap">
          <span @click="active = 1" class="tab" :class="active == 1 ? 'active' : ''">电子发票</span>
          <span @click="active = 2" class="tab" :class="active == 2 ? 'active' : ''">纸质发票</span>
        </div>
        <template v-if="active == 2">
          <div class="img">
            <div class="title">邮寄发票</div>
            <P class="notice">请输入准确的快递公司及单号</P>
          </div>
          <div class="list-item">
            <div class="label">快递公司</div>
            <input v-model="form.deliveryCompany" placeholder="请输入快递公司，例顺丰快递" type="text" class="big-input" />
          </div>
          <div class="list-item">
            <div class="label">快递单号</div>
            <input v-model="form.deliveryId" placeholder="请输入快递单号" type="text" class="big-input" />
          </div>
        </template>
        <div v-if="active == 1" class="img">
          <div class="title">上传发票</div>
          <P class="notice">尽量上传PDF，若选择上传图片形式发票请保证光源清晰，拍摄清楚</P>
          <!-- 上传图片 -->
          <van-uploader
            v-model="fileList"
            :before-read="beforeRead"
            :accept="$tools.android && $tools.isWeiXin() ? '' : 'image/jpeg,image/png,application/pdf'"
            :after-read="update"
            :multiple="$tools.android && $tools.isWeiXin() ? false : true"
            @click-preview="preview"
          />
        </div>
      </div>
      <van-button v-if="!needSign" class="withdrawCash ok-btncolor" :class="showBtn ? 'active' : 'disabled'" @click="showBtn && sureWithdrawal()"
        >确认提现</van-button
      >
      <van-button v-else class="withdrawCash ok-btncolor" :class="postList.cardNo ? 'active' : 'disabled'" @click="postList.cardNo && openSign()"
        >收据已生成，请您签名</van-button
      >
    </div>
    <div v-else class="informationList">
      <receiptTable ref="receiptTableRef" :form="form" @goSign="openSign" :detail="detail" />
      <van-button class="withdrawCash ok-btncolor active" @click="sureWithdrawal()">确认提现</van-button>
    </div>
    <div class="explain-wrap" v-if="!needSign">
      <div class="explain-title">
        <span>注意事项</span>
      </div>
      <div class="explain-title2">一、开票信息</div>
      <div class="explain-text bottom0">请根据入职机构查询开票方式及开票信息</div>
      <div class="select-box" :class="{ 'gray': !curCompany.name }" @click="$refs.selectCompanyPopup.open(curCompany)">
        {{ curCompany.name || '请选择所属机构' }}
      </div>
      <div class="explain-text" v-html="curCompany.text" v-if="curCompany.text"></div>
      <div class="explain-text">
        <span>1.开具发票：</span>
        <span>请根据申请金额开具税前服务费发票；</span>
      </div>
      <div class="explain-text">
        <span>2.发票填写：</span>
        <span>请根据开票信息，确保发票抬头、发票项目、发票金额准确无误（与本次提现金额保持一致）；</span>
      </div>
      <div class="explain-title2 top">二、开票流程（以湖北为例）</div>
      <div class="explain-text">
        <span>1、下载“楚税通”app——注册登录——我的——切换页面风格（省局优化版）——发票使用，代开电子普票；</span>
      </div>
      <div class="explain-text">
        <span>2、填写购买方信息——选择商品、劳务或服务类型——选择【销售服务】——【现代服务】——填写发票明细，服务名称为：“经纪代理服务”</span>
      </div>
    </div>
    <signPanel ref="signPanel" bgTxt="签名区" :show-close-btn="false" :username="userinfo.nickName" @confirm="handleConfirmSign" />
    <!-- 选择开票分公司 -->
    <select-company-popup ref="selectCompanyPopup" @save="curCompany = $event"></select-company-popup>

    <confirmWithdrawalPopup ref="confirmWithdrawalPopupRef" @jumpBankSet="jumpBankSet" @reload="backPage" />
  </div>
</template>

<script>
import html2Canvas from 'html2canvas';
import receiptTable from './components/receiptTable';
import selectCompanyPopup from './components/selectCompanyPopup';
import confirmWithdrawalPopup from '../components/confirmWithdrawalPopup';
import signPanel from '@/components/signPanel';
import imageSelect from '@/components/tools/imageSelect';
import { common } from '@/api/mixins';
export default {
  mixins: [common],
  components: { imageSelect, signPanel, receiptTable, selectCompanyPopup, confirmWithdrawalPopup },
  data() {
    return {
      loading: true,
      needSign: true,
      // 当前选择的开票公司
      curCompany: {
        name: '总公司',
        text: `<p>开票方式：下载楚税通APP</p>
        <p>户名：梧桐树保险经纪有限公司</p>
        <p>纳税人识别号：91440000796298438D</p>`
      },
      active: 1,
      form: {
        settleNumbers: [],
        availableAmount: '',
        requestAmount: '',
        deliveryCompany: '',
        deliveryId: '',
        detail: [],
        receipt: '', //收据
        receiptSign: '' //签名
      },
      detail: {},
      postList: [],
      fileList: [],
      userinfo: {}
    };
  },
  computed: {
    showBtn() {
      return (this.active == 1 && this.fileList.length > 0) || (this.active == 2 && this.form.deliveryCompany && this.form.deliveryId);
    }
  },
  beforeCreate() {
    this.$tools.setWebTitle('确认提现');
  },
  beforeDestroy() {
    sessionStorage.removeItem('wtsSignInfo');
  },
  created() {
    if (sessionStorage.getItem('wtsSignInfo')) {
      this.form.receiptSign = sessionStorage.getItem('wtsSignInfo');
      this.$nextTick(() => {
        this.getInfo();
      });
    }
    if (sessionStorage.confirmWithdrawalPopup) {
      this.active = sessionStorage.confirmWithdrawalPopupActive;
      this.needSign = sessionStorage.confirmWithdrawalPopupNeedSign;
      this.form = JSON.parse(sessionStorage.confirmWithdrawalPopupForm);
      this.fileList = JSON.parse(sessionStorage.confirmWithdrawalFileList);
      sessionStorage.removeItem('confirmWithdrawalPopup');
      sessionStorage.removeItem('confirmWithdrawalPopupActive');
      sessionStorage.removeItem('confirmWithdrawalPopupNeedSign');
      sessionStorage.removeItem('confirmWithdrawalPopupForm');
      sessionStorage.removeItem('confirmWithdrawalFileList');
      this.$nextTick(() => {
        this.addCashWithdraw();
      });
    }
    this.needSign = Math.max(500, Number(this.$route.query.request)) == 500;
    this.form.availableAmount = this.$route.query.money;
    this.form.requestAmount = this.$route.query.request;
    this.form.settleNumbers = this.$route.query.item;
    this.getBankInfo();
    this.getUserInfo();
  },
  methods: {
    jumpBankSet() {
      sessionStorage.confirmWithdrawalPopupActive = this.active;
      sessionStorage.confirmWithdrawalPopupNeedSign = this.needSign;
      sessionStorage.confirmWithdrawalPopupForm = JSON.stringify(this.form);
      sessionStorage.confirmWithdrawalFileList = JSON.stringify(this.fileList);
    },
    backPage() {
      setTimeout(() => {
        this.$router.go(-2);
      }, 200);
    },
    getInfo() {
      this.$http({
        type: 'GET',
        url: '/api/userBase/receiptDetail',
        data: {
          amount: this.form.requestAmount
        }
      }).then(res => {
        this.detail = res.data;
      });
    },
    openSign() {
      this.$tools.setWebTitle('电子签名');
      this.$refs.signPanel.open();
    },
    // 返回布尔值
    beforeRead(file) {
      console.log(file);
      let allowType = ['image/jpeg', 'image/png', 'application/pdf', 'image/jpg'];
      if (!allowType.includes(file.type)) {
        this.$notice.msg('请上传图片或DPF');
        return false;
      }
      return true;
    },
    preview(val) {
      if (val.url.indexOf('.pdf') != -1) {
        if (this.$config.isApp) {
          this.$app.readPdf({
            url: val.url,
            title: val.file.name
          });
        } else {
          this.$app.openWeb(val.url);
        }
      }
    },
    //缓存签字信息
    cacheInsuredInfo() {
      sessionStorage.setItem('wtsSignInfo', this.resultImg);
    },
    handleConfirmSign(signData) {
      console.log(signData);
      this.$refs.signPanel.close();
      this.$tools.setWebTitle('确认提现');
      this.loading = true;
      // 1.先转为 blob格式
      let blob = this.dataURLtoBlob(signData.signInfo);
      // 2，在转为 file类型
      let file = this.blobToFile(blob, '电子签名.jpg');

      // 3.上传
      let param = new FormData(); //创建form对象
      param.append('file', file); //通过append向form对象添加数据
      this.$http({
        url: '/resmgr/upload',
        data: param,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        this.resultImg = res.data[0].url;
        this.cacheInsuredInfo();
        this.form.receiptSign = res.data[0].url;
        this.loading = false;
        if (!this.detail.receiptNo) {
          this.$nextTick(() => {
            this.getInfo();
          });
        }
      });
    }, //1,先将base64转换为blob
    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    //2,再将blob转换为file
    blobToFile(theBlob, fileName) {
      theBlob.lastModifiedDate = new Date(); // 文件最后的修改日期
      theBlob.name = fileName; // 文件名
      return new File([theBlob], fileName, { type: theBlob.type, lastModified: Date.now() });
    },
    getUserInfo() {
      this.loading = true;
      this.$http({
        type: 'GET',
        url: '/api/userBase/getUserInfo',
        data: {}
      }).then(res => {
        this.userinfo = res.data;
      });
    },
    //获取银行卡信息
    getBankInfo() {
      this.loading = true;
      this.$http({
        type: 'GET',
        url: '/api/userWithdrawLog/read/info',
        data: {}
      })
        .then(res => {
          this.loading = false;
          this.postList = res.data;
        })
        .catch(e => {
          this.loading = false;
        });
    },
    /**
     * 上传图片
     */
    update(file, detail) {
      let param = new FormData(); //创建form对象
      console.log(file);
      if (Array.isArray(file)) {
        file.map(item => {
          item.status = 'uploading';
          item.message = '上传中...';
          param.append('file', item.file);
        });
      } else {
        file.status = 'uploading';
        file.message = '上传中...';
        param.append('file', file.file); //通过append向form对象添加数据
      }
      this.$http({
        url: '/resmgr/upload',
        data: param,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(res => {
          if (Array.isArray(file)) {
            file.forEach((item, i) => {
              item.url = res.data[i].path;
              item.status = 'done';
              item.message = '';
            });
          } else {
            file.url = res.data[0].path;
            file.status = 'done';
            file.message = '';
          }
        })
        .catch(err => {
          console.log(err);
          this.fileList = this.fileList.filter(item => item.url != url);
        });
    },
    getResult() {
      let arr = [];
      if (this.fileList.length > 0) {
        arr = this.fileList.map(item => {
          if (item) {
            return { fileName: item.file.name, path: item.url };
          }
        });
      }
      this.form.detail = arr;
    },
    canvas2Image(canvas, width, height) {
      const retCanvas = document.createElement('canvas');
      const retCtx = retCanvas.getContext('2d');
      retCanvas.width = width;
      retCanvas.height = height;
      retCtx.drawImage(canvas, 0, 0, width, height);
      if (this.$route.query.isShare) {
        this.shareImg = retCanvas.toDataURL('image/jpeg');
        this.loading = false;
      } else {
        this.upload(retCanvas.toDataURL('image/jpeg'));
      }
      this.show = false;
    },
    dataURLtoFile(dataURI, type) {
      let binary = atob(dataURI.split(',')[1]);
      let array = [];
      for (let i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
      }
      return new Blob([new Uint8Array(array)], { type: type });
    },
    upload(baseStr, index) {
      let imgBase = baseStr;
      let blob = this.dataURLtoFile(imgBase, 'image/jpeg');
      var formData = new FormData();
      let fileOfBlob = new File([blob], new Date() + '.jpg'); // 重命名了
      formData.append('faceInfo', fileOfBlob);
      this.$http({
        url: '/resmgr/upload',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        this.form.receipt = res.data[0].path;
        this.addCashWithdraw();
      });
    },
    addCashWithdraw() {
      let form = JSON.parse(JSON.stringify(this.form));
      if (this.active == 1) {
        delete form.deliveryCompany;
        delete form.deliveryId;
      } else {
        delete form.detail;
      }
      this.$refs.confirmWithdrawalPopupRef.open(null, {
        ids: this.$route.query.ids,
        ...form
      });
    },
    sureWithdrawal() {
      this.getResult();
      if (this.form.receiptSign) {
        const dom = document.querySelector('.receipt-wrap');
        html2Canvas(dom, {
          allowTaint: false,
          taintTest: false,
          logging: false,
          useCORS: true,
          dpi: Number(document.documentElement.getAttribute('data-dpr')) * 4, // 将分辨率提高到特定的DPI 提高四倍
          scale: 4 // 按比例增加分辨率
        }).then(canvas => {
          const context = canvas.getContext('2d');
          // 关闭抗锯齿形
          context.mozImageSmoothingEnabled = false;
          context.webkitImageSmoothingEnabled = false;
          context.msImageSmoothingEnabled = false;
          context.imageSmoothingEnabled = false;
          // canvas转化为图片
          this.canvas2Image(canvas, 600, parseInt((canvas.height / canvas.width) * 600));
        });
        return;
      }
      this.addCashWithdraw();
    }
  }
};
</script>

<style lang="scss" scoped>
@import './confirmedWithdrawal.scss';
/deep/.van-uploader__preview-delete {
  background-color: transparent;
}
.active {
  background-color: #ff8b00 !important;
  color: #ffffff;
}
/deep/.van-uploader__file {
  &::after {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0px;
    right: 0px;
    left: 0;
    bottom: 0;
    background: url('~@static/images/icon-pdf.png') no-repeat center;
    background-size: 100%;
  }
}
/deep/.van-uploader__preview-delete-icon {
  &::before {
    content: '';
    width: 64px;
    height: 64px;
    position: absolute;
    top: -16px;
    right: -16px;
    background: url('~@static/images/icon-del.png') no-repeat center;
    background-size: 100%;
  }
}
</style>